import { render, staticRenderFns } from "./Scheme8.vue?vue&type=template&id=47109036&scoped=true"
import script from "./Scheme8.vue?vue&type=script&lang=js"
export * from "./Scheme8.vue?vue&type=script&lang=js"
import style0 from "./Scheme8.vue?vue&type=style&index=0&id=47109036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47109036",
  null
  
)

export default component.exports